<script>
import Liveblog from '@/services/Liveblog'

export default {
    props: {
        matchId: {
            type: String,
            default: '',
        },
        match: {
            type: Object,
            default: null,
        },
        pushNotifEnabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tryingToSubmit: false,
        }
    },
    computed: {
        matchLabel() {
            if (!this.match) return 'this match'
            return `${this.match.home_team_code} vs ${this.match.away_team_code}`
        },
        isEnableAction() {
            return !this.pushNotifEnabled
        },
    },
    methods: {
        open() {
            this.tryingToSubmit = false
            this.$refs.modal.show()
        },
        hide() {
            this.$refs.modal.hide()
        },
        async confirm() {
            if (!this.matchId || this.tryingToSubmit) return

            this.tryingToSubmit = true
            try {
                const nextValue = this.isEnableAction ? 1 : 0
                await Liveblog.setTimelineSettings(this.matchId, { push_notif: nextValue })
                this.$emit('saved', { push_notif: nextValue })
                this.hide()
            } catch (error) {
                this.$emit(
                    'error',
                    error.response?.data?.error || 'Failed to update push notification setting'
                )
            } finally {
                this.tryingToSubmit = false
            }
        },
    },
}
</script>

<template>
    <b-modal
        ref="modal"
        size="md"
        hide-header
        hide-footer
        body-class="p-0"
        centered
    >
        <div class="marketing-modal">
            <header class="marketing-modal__hero marketing-modal__hero--row">
                <div>
                    <h2>{{ isEnableAction ? 'Enable push notifications' : 'Disable push notifications' }}</h2>
                    <p>Control match push notifications driven from the liveblog timeline</p>
                </div>
                <button type="button" class="btn-close" aria-label="Close" @click="hide"></button>
            </header>

            <section class="marketing-card">
                <header class="marketing-card__header">
                    <h3>{{ matchLabel }}</h3>
                    <p v-if="isEnableAction">
                        Users can receive match notifications driven from liveblog entries of type Event.
                    </p>
                    <p v-else>
                        No push notifications will be sent for this match timeline.
                    </p>
                </header>
            </section>

            <footer class="marketing-modal__footer">
                <b-button variant="outline-secondary" :disabled="tryingToSubmit" @click="hide">
                    Cancel
                </b-button>
                <b-button
                    :variant="isEnableAction ? 'dark' : 'danger'"
                    :disabled="tryingToSubmit"
                    @click="confirm"
                >
                    <b-spinner v-if="tryingToSubmit" small class="me-2" />
                    {{ isEnableAction ? 'Enable' : 'Disable' }}
                </b-button>
            </footer>
        </div>
    </b-modal>
</template>

<style scoped lang="scss">
@import '@/assets/scss/marketing-modal';

.marketing-modal__hero h2 {
  font-size: 22px;
}
</style>
